<ng-container appCoreRenderTemplate [data]="data"></ng-container>
